export const TESTIMONIAL_INNER_CONTAINER_ONE =
    "max-w-full md:max-w-[60%]  mx-2 md:mx-auto ";
export const TESTIMONIAL_INNER_CONTAINER_TWO =
    " max-w-full lg:max-w-[80%] mx-3 sm:mx-auto bg-New_Secondary_Background  NewHome_Testimonial_border";
export const TESTIMONIAL_INNER_CONTAINER_THREE =
    "custom-slick-testimonials flex flex-col  h-full p-5 sm:p-10 pb-16 sm:pb-24 ";
